import httpService from "../../components/service";

export const details = {
    namespaced: true,
    state: {
        basket: {}
    },
    getters: {
        getBasket: state => state.basket
    },
    mutations: {
        SET_BASKET(state, basket) {
            state.basket = basket;
        },
        UPDATE_BASKET(state, newBasket) {
            state.basket = newBasket;
        },
        DELETE_BASKET_ITEM(state, res) {
            state.basket = res;
        }
    },
    actions: {
        async getBasketAction(context, basketId) {
            const res = await httpService.get("/baskets/" + basketId);
            context.commit("SET_BASKET", res);
            return res;
        },

        async placeOrder(context, basketId) {
            let orderObject = { baskets: [{ id: basketId }] };
            const res = await httpService.post("/orders", JSON.stringify(orderObject));
            if (res.code) throw Error(res.message);
            return res;
        },
        async addItemBasket(context, data) {
            const res = await httpService.post("/baskets/" + data.basketId + "/item", JSON.stringify(data.item));
            if (res.code) throw Error(res.message);
            context.commit("UPDATE_BASKET", res);
            return res;
        },
        async updateBasket(context, basket) {
            const res = await httpService.put("/basketItem/" + basket.id, JSON.stringify(basket));
            context.commit("UPDATE_BASKET", res);
            return res;
        },
        async deleteBasketItemAction(context, basketItemId) {
            const res = await httpService.delete("/basketItem/" + basketItemId + "/delete", {});
            context.commit("DELETE_BASKET_ITEM", res);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/basket/details.js